import hoverintent from 'hoverintent';
import onDOMContentLoaded from '../utils/on-dom-content-loaded';
import toggleAriaExpanded from '../utils/toggle-aria-expanded';

const setHeaderZIndex = (zIndex) => {
  const header = document.querySelector('header');

  header.style.setProperty('--header-z-index', zIndex);
};

// mobile menu functions

const toggleMobileMenuIcon = () => {
  const mobileNavToggle = document.querySelector('.js-toggle-mobile-nav');
  const mobileMenuIcon = mobileNavToggle.querySelector('.material-icons-round');

  if (mobileMenuIcon.innerHTML.trim() === 'menu') {
    mobileMenuIcon.innerHTML = 'close';
  } else {
    mobileMenuIcon.innerHTML = 'menu';
  }
};

export const closeAllMenuLevels = (delayTime) => {
  const topLevelItems = document.querySelectorAll('.js-top-level-item');
  const mobileNav = document.querySelector('.js-navigation-menu');

  if (mobileNav.style.getPropertyValue('--main-nav-display') === 'block') {
    setTimeout(() => {
      mobileNav.style.setProperty('--main-nav-display', 'none');
    }, delayTime);
  }

  topLevelItems.forEach((item) => {
    const subMenuWrapper = item.nextElementSibling;
    const subMenu = subMenuWrapper.querySelector('.js-submenu-mobile');

    subMenu.classList.remove('transition-out');
    subMenu.classList.remove('transition-in');
    subMenu.classList.toggle('hidden');
    item.setAttribute('aria-expanded', false);
  });

  const backButtons = document.querySelectorAll('.js-submenu-back');
  backButtons.forEach((backButton) => {
    const backButtonParent = backButton.parentElement;
    const currentMenuLevelTriggerElement =
      backButton.closest('.submenu-wrapper').previousElementSibling;
    backButtonParent.classList.remove('transition-out');
    backButtonParent.classList.remove('transition-in');

    currentMenuLevelTriggerElement.setAttribute('aria-expanded', false);
    if (!backButtonParent.classList.contains('hidden')) {
      backButtonParent.classList.add('hidden');
    }
  });
};

const toggleMobileNav = () => {
  const mobileNavToggle = document.querySelector('.js-toggle-mobile-nav');
  const mobileNav = document.querySelector('.js-navigation-menu');
  const body = document.querySelector('body');

  mobileNavToggle.addEventListener('click', () => {
    const mobileNavDisplayValue =
      mobileNav.style.getPropertyValue('--main-nav-display') === 'none' ||
      !mobileNav.style.getPropertyValue('--main-nav-display')
        ? 'block'
        : 'none';

    if (mobileNavDisplayValue === 'block') {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }

    toggleMobileMenuIcon();

    if (mobileNavDisplayValue === 'none') {
      mobileNav.classList.remove('transition-in');
      mobileNav.classList.add('transition-out');
      mobileNavToggle.setAttribute('aria-expanded', false);
      closeAllMenuLevels(400);
      setHeaderZIndex(510);
    } else {
      mobileNav.style.setProperty('--main-nav-display', mobileNavDisplayValue);
      mobileNav.classList.remove('transition-out');
      mobileNav.classList.add('transition-in');
      mobileNavToggle.setAttribute('aria-expanded', true);
      setHeaderZIndex(600);
    }
  });
};

const topLevelItemClickHandler = () => {
  const topLevelItems = document.querySelectorAll('.js-top-level-item');
  topLevelItems.forEach((item) => {
    item.addEventListener('click', () => {
      const subMenuWrapper = item.nextElementSibling;
      const subMenu = subMenuWrapper.children[1];

      subMenu.classList.toggle('hidden');
      subMenu.classList.remove('transition-out');
      subMenu.classList.toggle('transition-in');
      toggleAriaExpanded(item);
    });
  });
};

const backButtonClickHandler = () => {
  const backButtons = document.querySelectorAll('.js-submenu-back');

  backButtons.forEach((backButton) => {
    const backButtonParent = backButton.parentElement;
    const currentMenuLevelTriggerElement =
      backButton.closest('.submenu-wrapper').previousElementSibling;

    backButton.addEventListener('click', () => {
      backButtonParent.classList.toggle('transition-out');
      backButtonParent.classList.toggle('transition-in');
      toggleAriaExpanded(currentMenuLevelTriggerElement);
      setTimeout(() => {
        backButtonParent.classList.toggle('hidden');
      }, 400);
    });
  });
};

// desktop menu functions

const setMegaMenuHeight = (topLevelItem) => {
  const openMenu = topLevelItem.nextElementSibling.querySelector('.js-submenu-desktop');
  const container = topLevelItem.parentElement.parentElement;
  let tallestSubmenus = 0;
  if (container && container.classList.contains('menu-list')) {
    const menuHeight = openMenu.children[0].offsetHeight;

    tallestSubmenus = menuHeight;

    openMenu.querySelectorAll('.js-submenu-desktop').forEach((tertiaryMenu) => {
      const tertiaryMenuHeight = tertiaryMenu.children[0].offsetHeight;
      if (tertiaryMenuHeight > tallestSubmenus) {
        tallestSubmenus = tertiaryMenuHeight;
      }
    });

    const menuItem = topLevelItem.nextElementSibling.querySelector('.js-submenu-desktop');
    menuItem.style.height = `${tallestSubmenus / 10}rem`;
  }
};

const removeHeaderBoxShadow = () => {
  const header = document.querySelector('header');

  const openMenus = document.querySelectorAll('.js-submenu-desktop:not(.visibility-hidden)');

  if (openMenus.length === 0) {
    header.classList.remove('menu-is-open');
  }
};

const toggleTopNavIcon = (item) => {
  const topLevelIcon = item.querySelectorAll('.icon-desktop')[0];

  if (topLevelIcon.innerHTML.trim() === 'expand_more') {
    topLevelIcon.innerHTML = 'expand_less';
  } else {
    topLevelIcon.innerHTML = 'expand_more';
  }
};

const desktopNavHoverInHandler = (item) => {
  setHeaderZIndex(600);
  const subMenuWrapper = item.nextElementSibling;
  const subMenuDesktop = subMenuWrapper.children[0];

  subMenuDesktop.classList.toggle('visibility-hidden');
  setTimeout(() => {
    window.isMenuOpen = true;
  }, 250); // time is 50ms longer than the hoverintent timeout

  setTimeout(() => {
    subMenuDesktop.classList.toggle('opacity-transition');
  }, 50);

  const tertiaryMenu = subMenuWrapper.querySelector(
    '.js-submenu-desktop:not(.visibility-hidden) > .submenu-list-wrapper .js-submenu-desktop.visibility-hidden'
  );
  if (tertiaryMenu) {
    tertiaryMenu?.classList?.remove('visibility-hidden');
    toggleAriaExpanded(tertiaryMenu?.parentElement?.previousElementSibling);
  }
  setMegaMenuHeight(item);
  toggleAriaExpanded(item);
  setTimeout(() => {
    toggleTopNavIcon(item);
  }, 100);
};

const desktopNavHoverOutHandler = (item) => {
  const hoverIntentOutEvent = new Event('hoverIntentOutEvent');
  const subMenuWrapper = item.nextElementSibling;
  const subMenuDesktop = subMenuWrapper.children[0];

  const tertiaryMenu = subMenuWrapper.querySelectorAll(
    '.js-submenu-desktop > .submenu-list-wrapper .js-submenu-desktop'
  );

  subMenuDesktop.classList.toggle('opacity-transition');
  window.isMenuOpen = false;

  setTimeout(() => {
    subMenuDesktop.classList.toggle('visibility-hidden');
  }, 300);

  toggleTopNavIcon(item);
  toggleAriaExpanded(item);
  tertiaryMenu.forEach((tertiaryMenuItem) => {
    tertiaryMenuItem.classList.add('visibility-hidden');
    tertiaryMenuItem.parentElement.previousElementSibling.setAttribute('aria-expanded', false);
  });

  removeHeaderBoxShadow();
  window.dispatchEvent(hoverIntentOutEvent);
};

const desktopTertiaryMenuHoverInHandler = (item) => {
  const submenuList = item.parentElement.parentElement;
  const currentDisplayedSubmenu = submenuList.querySelectorAll(
    '.js-submenu-desktop:not(.visibility-hidden)'
  )?.[0];
  const subMenuWrapper = item.nextElementSibling;
  const subMenuDesktop = subMenuWrapper.children[0];

  if (currentDisplayedSubmenu) {
    const currentDisplayedSubmenuTriggerElement =
      currentDisplayedSubmenu.parentElement.previousElementSibling;

    toggleAriaExpanded(currentDisplayedSubmenuTriggerElement);
    currentDisplayedSubmenu.classList.toggle('visibility-hidden');
  }

  subMenuDesktop.classList.toggle('visibility-hidden');
  setMegaMenuHeight(item);
  toggleAriaExpanded(item);
};

const toggleDesktopTertiary = () => {
  const subMenuDesktopElements = document.querySelectorAll('.js-submenu-desktop');

  subMenuDesktopElements.forEach((subMenuDesktop) => {
    const tertiaryMenuToggleButtons = subMenuDesktop.querySelectorAll('.js-top-level-item');

    tertiaryMenuToggleButtons.forEach((button) => {
      hoverintent(
        button.parentElement,
        () => desktopTertiaryMenuHoverInHandler(button),
        () => null
      ).options({ timeout: 250, sensitivity: 1 });

      button.addEventListener('keydown', (e) => {
        if (e.code === 'Enter') {
          desktopTertiaryMenuHoverInHandler(button);
        }
      });
    });
  });
};

const closeAllDesktopMenus = () => {
  const topLevelItems = document.querySelectorAll('.js-top-level-item');

  topLevelItems.forEach((item) => {
    const subMenuWrapper = item.nextElementSibling;
    const subMenu = subMenuWrapper.querySelector('.js-submenu-desktop');
    if (!subMenu.classList.contains('visibility-hidden')) {
      desktopNavHoverOutHandler(item);
    }
  });
};

const toggleDesktopNav = () => {
  const topLevelItems = document.querySelectorAll(
    '.menu-list > .menu-list-item > .js-top-level-item'
  );

  topLevelItems.forEach((item) => {
    hoverintent(
      item.parentElement,
      () => desktopNavHoverInHandler(item),
      () => desktopNavHoverOutHandler(item)
    ).options({ timeout: 200, interval: 100 });

    item.addEventListener('keydown', (e) => {
      const topLevelMenuIsOpen = !item.nextElementSibling
        .querySelectorAll('.js-submenu-desktop')[0]
        .classList.contains('visibility-hidden');

      if (e.code === 'Enter') {
        if (topLevelMenuIsOpen) {
          desktopNavHoverOutHandler(item);
        } else {
          closeAllDesktopMenus();
          desktopNavHoverInHandler(item);
        }
      }
    });
  });

  window.addEventListener('hoverIntentOutEvent', () => {
    setHeaderZIndex(510);
  });
};

const initMobileNavHandler = () => {
  const isMobile = window.innerWidth < 992;
  if (isMobile) {
    toggleMobileNav();
    topLevelItemClickHandler();
    backButtonClickHandler();
  } else if (window.innerWidth >= 992) {
    toggleDesktopNav();
    toggleDesktopTertiary();
  }
};

onDOMContentLoaded().then(() => initMobileNavHandler());
